import { useEffect, useState } from 'react';
import BinaryTradingBot from '../binary_trading_bot';
import './mode_panel/mode_panel.css';
import Login from './pages/Login';
import { getAccount, createEmailSession, createAnonymousSession } from './services/appwriteAuth';
import { ensureProfileForAccount } from './services/appwriteUsers';
import { pingAppwriteDb } from './services/appwriteHealth';
import { recordLoginEvent } from './services/appwriteAudit';
import { locale } from './lib/appwrite';

function App() {
  const [user, setUser] = useState<any>(null);
  const [checking, setChecking] = useState(true);




  useEffect(() => {
    (async () => {
      const acc = await getAccount();
      if (acc) { try { await ensureProfileForAccount(acc); } catch {} }
      setUser(acc);
      setChecking(false);
    })();
  }, []);

  // SDK-based connectivity ping (public, no auth) — helps Console mark platform as connected
  useEffect(() => {
    (async () => {
      try {
        const res = await locale.get();
        console.log('Appwrite SDK ping (locale):', res);
      } catch (e) {
        console.error('Appwrite SDK ping (locale) failed', e);
      }
    })();
  }, []);

  // Appwrite DB connectivity ping (non-SDK). Safe to keep for diagnostics, but not required.
  useEffect(() => {
    (async () => {
      try {
        const res = await pingAppwriteDb();
        console.log('Appwrite DB ping:', res);
      } catch (e) {
        console.error('Appwrite DB ping failed', e);
      }
    })();
  }, []);

  const handleLogin = async (email: string, password: string) => {
    await createEmailSession(email, password);
    const acc = await getAccount();
    if (!acc || !acc.$id) {
      console.warn('Login session not established. If using Appwrite Cloud, allow third-party cookies for cloud.appwrite.io or use a custom domain.');
      return;
    }
    try { await ensureProfileForAccount(acc); } catch {}
    try { await recordLoginEvent(acc); } catch {}
    setUser(acc);
  };

  const handleAnonymousLogin = async () => {
    await createAnonymousSession();
    const acc = await getAccount();
    if (!acc || !acc.$id) {
      console.warn('Anonymous session not established. If using Appwrite Cloud, allow third-party cookies for cloud.appwrite.io or use a custom domain.');
      return;
    }
    try { await ensureProfileForAccount(acc); } catch {}
    try { await recordLoginEvent(acc); } catch {}
    setUser(acc);
  };


  if (checking) {
    return (
      <div className="min-h-screen bg-black text-white flex items-center justify-center">Loading…</div>
    );
  }

  return (
    <div className="min-h-screen bg-black text-white">
      {!user ? (
        <Login onLogin={handleLogin} onAnonymousLogin={handleAnonymousLogin} />
      ) : (
        <BinaryTradingBot />
      )}
    </div>
  );
}

export default App;